/* OsPlanExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class OsPlanExplorerLmrbComponent extends GameEditor {
    constructor(
        logger,
        editorLayout,
        userSession,
        OsUpgradePlan,
        solutionManager,
        OsUpgradePlanPrefs,
        storageFactory,
        AutoCapturePrefs,
        di
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._isCatalogEnable = false;
        this._osPlanEntityDef = OsUpgradePlan;
        this._solutionManager = solutionManager;
        this._osUpgradePrefs = OsUpgradePlanPrefs;
        this._storageFactory = storageFactory;
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._di = di;
        this._autoCapturePrefs = AutoCapturePrefs;
        this._autoCapturePrefsEntity = undefined;

        this._updateNameSpaces();

        this._registerPlanExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("os-plan-explorer-lmrb");

                return Promise.all([
                    this.whenInitialized(),
                    this.whenGameEditorStorageIsReady(),
                ]).then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");

            switch (currentViewName) {
                case "plan":
                    currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
                    break;
                case "catalog":
                    currentView = Registrations.OS_CATALOG_EXPLORER_LMRB;
                    break;
                case "device":
                    currentView = Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "iot_device":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "iotplan":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                            : Registrations.OS_PLAN_EXPLORER_LMRB;
                    break;
                case "platform":
                    currentView =
                        Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                            ? Registrations.PLATFORM_EXPLORER_LMRB
                            : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                default:
                    currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
            }

            return currentView;
        }
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    get isOsUpgradeAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsUpgrade", false);
    }

    get isOsTransferAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsTransfer", false);
    }

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "osPlanExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "osPlanExplorer.actionNamespaces", []);

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _registerPlanExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        // this._userSession.on(
        //     "OrganizationChange",
        //     (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        // );

        Steve.controlAppNav.on(
            "OrganizationChanged",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );

        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
    }

    _unregisterPlanExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (Steve.controlAppNav) {
            Steve.controlAppNav.removeListener("OrganizationChanged", this._onOrganizationChange);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    whenInitialized(refreshNamespaces = false) {
        return Promise.resolve()
            .then(() => {
                this._activeOrgId = this._userSession.activeOrganization.id;
                if (refreshNamespaces) {
                    this._updateNameSpaces(true);
                }
                return Promise.resolve();
            })
            .then(() => {
                return this._autoCapturePrefs.loadAscendAutoCapturePrefs(this._activeOrgId, {});
            })
            .then((autoCapturePrefsEntity) => {
                this._autoCapturePrefsEntity = autoCapturePrefsEntity;
                return this._osUpgradePrefs.loadPrefs(this._activeOrgId);
            })
            .then((osUpgrade) => {
                this._osPlanPrefs = osUpgrade;
                this._isCatalogEnable = _.get(osUpgrade, "enableCatalogs");

                const isXdomeEnabled = Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled;
                if (!isXdomeEnabled) {
                    this.hideBarView(Registrations.OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(Registrations.PLATFORM_EXPLORER_LMRB);

                    this.hideBarView(Registrations.OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                    );
                    this.hideBarView(Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                    );
                } else {
                    const activeParts = this._LMRBLayout.state.bottom.getActiveParts();
                    if (
                        !activeParts.find(
                            (part) =>
                                part.id === Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                        )
                    ) {
                        this._LMRBLayout.state.bottom.addPart(
                            Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB,
                            Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                        );
                    }
                    if (
                        !activeParts.find(
                            (part) => part.id === Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                        )
                    ) {
                        this._LMRBLayout.state.bottom.addPart(
                            Registrations.IOT_OS_PLAN_EXPLORER_LMRB,
                            Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                        );
                    }
                }

                if (!this._isCatalogEnable) {
                    this.hideBarView(Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG);
                    //remove the bottom bar icon
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.OS_CATALOG_EXPLORER_LMRB
                    );
                } else {
                    let nonActivePartsIds =
                        this._LMRBLayout.state.bottom.getNonActiveAvailablePartsIds();

                    if (
                        nonActivePartsIds.find(
                            (partId) => partId === Registrations.OS_CATALOG_EXPLORER_LMRB
                        )
                    ) {
                        this._LMRBLayout.state.bottom.addPart(
                            Registrations.OS_CATALOG_EXPLORER_LMRB,
                            Registrations.OS_CATALOG_EXPLORER_LMRB
                        );
                    }
                }
                return Promise.resolve();
            });
    }

    launchPlanEditor(editorState, launchOpts) {
        const planId = launchOpts.id;
        const plansIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = plansIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);
        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    planId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.OS_PLAN_EDITOR,
                    launchOpts
                );
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    shutdown() {
        let shutdowns = [];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterPlanExplorerListeners();
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._osPlanEntityDef = undefined;
                this._isCatalogEnable = undefined;
                this._filterFromUrl = undefined;
                this._autoCapturePrefs = undefined;
                this._autoCapturePrefsEntity = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "OSPlanExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.OS_PLAN_EXPLORER_LMRB)
        // ) {
        //     this.whenInitialized()
        //         .then(() => {
        //             this._updateNameSpaces(true);
        //             this.renderer.render();
        //         });
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange(newOrg, oldOrg) {
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this.renderer.render();
        }
    }

    /**
     * On a first visit, reopen previously opened solution
     */
    _switchSolution(view = "") {
        let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
        if (!_.isEmpty(view)) {
            currentExplorerView = view;
        }
        const isXdomeEnabled = Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled;

        if (
            currentExplorerView &&
            currentExplorerView === Registrations.OS_CATALOG_EXPLORER_LMRB &&
            this._isCatalogEnable
        ) {
            this.openLMRBExplorer(Registrations.OS_CATALOG_EXPLORER_LMRB);
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            this.openLMRBExplorer(Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB);
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.IOT_OS_PLAN_EXPLORER_LMRB
        ) {
            if (isXdomeEnabled) {
                this.openLMRBExplorer(Registrations.IOT_OS_PLAN_EXPLORER_LMRB);
            } else {
                this._cabinetCmpnt.selectView(Registrations.OS_PLAN_EXPLORER_GRID);
            }
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            if (isXdomeEnabled) {
                this.openLMRBExplorer(Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else {
                this.openLMRBExplorer(Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB);
            }
        } else if (
            currentExplorerView &&
            currentExplorerView === Registrations.PLATFORM_EXPLORER_LMRB
        ) {
            this.openLMRBExplorer(Registrations.PLATFORM_EXPLORER_LMRB);
        } else {
            this._cabinetCmpnt.selectView(Registrations.OS_PLAN_EXPLORER_GRID);
        }
        return;
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();

            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");

                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }
}

module.exports = OsPlanExplorerLmrbComponent;

OsPlanExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.entities.OsUpgradePlan",
    "$teve.solutionsManager",
    "$teve.entities.OsUpgradePlanPrefs",
    "$teve.storageFactory",
    "$teve.entities.AutoCapturePrefs",
    "$teve.di",
];
OsPlanExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
OsPlanExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
OsPlanExplorerLmrbComponent.$iconRepoName = "osmanager.os_plan_explorer";
OsPlanExplorerLmrbComponent.$openedByDefault = true;
OsPlanExplorerLmrbComponent.$displayName = "OS Plan Explorer";
